

//contact fixed bar 
document.querySelector('.fixed-contact-bar').addEventListener('click', () => {
  document.querySelector('.fixed-contact-container').classList.toggle('fixed-contact-open')
})
//mobile fixed bar
document.querySelector('.mobile-closed-form').addEventListener('click', () => {
  document.querySelector('.fixed-contact-container').classList.remove('fixed-contact-open')
})



//slider Scripts
import {
  sliderHome2
} from './modules/sliderHome';
sliderHome2();

import {
  sliderIcons
} from './modules/sliderIcons';
sliderIcons();

import {
  sliderTeam
} from './modules/sliderTeam';
sliderTeam();

import {
  sliderBrands
} from './modules/sliderBrands';
sliderBrands();

import {
  sliderComparison
} from './modules/sliderComparison';
sliderComparison();

import {
  knowledgeBase
} from './modules/knowledgeBase';
knowledgeBase();

//slider Scripts
import {
  sliderQuotations
} from './modules/sliderQuotations';
sliderQuotations();

//carousel center
import {
  carouselCenter
} from './modules/carouselCenter';
carouselCenter();

import {
  methodsCarouselMobile
} from './modules/methods-mobile-carousel';
methodsCarouselMobile();

//menu

//accordion
import "./modules/accordion.js";
//comparisonImage
import "./modules/comparisonImage.js";
//videoPlayer
import "./modules/videPlayer";
//paralax
import "./modules/paralaxScroll.js";
//fancybox
import "./modules/fancyboxVideo.js";
//sal scroll animation
import "./modules/scrollAnimation.js";
//clipboard share
import "./modules/share.js";

import "./modules/upload.js";





//footer gallery
import "./modules/footerGallery.js";
//text animation
import "./modules/textAnimation.js";
import "./modules/cookie.js";

import "../../inc/blocks/block-masonry/script.js";
import "../../inc/blocks/block-consultation/script.js";
import "../../inc/blocks/block-map/script.js";
import "../../inc/blocks/block-video-columns/script.js";


import "./modules/menu.js";






const onHoverMobile = document.querySelectorAll('.on-hover-content-mobile');

function toggleShowContent(e) {
  e.target.classList.toggle('show-content');
  const linkElement = e.target.firstElementChild;
  linkElement.classList.toggle('text-white');
  const myTimeout = setTimeout(hide, 3000);



  function hide() {
    e.target.classList.remove('show-content');

    
  }
}
if (onHoverMobile) {
  onHoverMobile.forEach(btn => btn.addEventListener('click', toggleShowContent));

}


import "./modules/paralaxScrollColumn.js";